import React from "react";
import { useStaffAuth } from "../../context/StaffAuthContext";
import Breadcrumb from "../../components/hub/Breadcrumb";
import HubSection from "../../components/hub/HubSection";

import { hubPayrollLinks } from "../../data/hub/hubPayrollLinks";

/**
 * Payroll hub. One component mounted at two routes in App.js:
 *   owner: /payroll              -> <PayrollHub isPortal={false} />
 *   staff: /staff-panel/payroll  -> <PayrollHub isPortal={true} />
 *
 * Icon styling is handled centrally by HubGrid -> HubIcon.
 */
const PayrollHub = ({ isPortal = false }) => {
  const { hasPermission } = useStaffAuth();

  return (
    <div className="min-h-screen bg-neutral-50/50 dark:bg-neutral-950 py-6 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">

        {/* Header & Breadcrumb */}
        <div className="space-y-2">
          <Breadcrumb
            items={[{ label: "Payroll" }]}
            homeUrl={isPortal ? "/staff-home" : "/school-home"}
          />

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pt-1 border-b border-neutral-200 dark:border-neutral-800/80 pb-4">
            <div>
              <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
                Payroll
              </h1>

              <p className="text-xs font-semibold text-neutral-500 dark:text-neutral-400 mt-0.5">
                Manage staff salaries, structure pay slips, allowances, and monthly disbursements.
              </p>
            </div>
          </div>
        </div>

        {/* Navigation Section Cards */}
        <div className="space-y-6">
          {hubPayrollLinks.map((section) => (
            <HubSection
              key={section.sectionTitle}
              title={section.sectionTitle}
              icon={section.sectionIcon}
              links={section.links}
              isPortal={isPortal}
              basePath="/staff-panel"
              hasPermission={hasPermission}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default PayrollHub;